export default __webpack_public_path__ + "static/media/land-6.8e9c4325.png";